module.exports = __webpack_public_path__ + "static/media/exterior10.8414c477.webp";